export class GeneralError extends Error {
  public constructor(reason?: string) {
    super()

    this.message = reason ? `generalErrors.${reason}` : 'generalErrors.default'
  }
}
